<div class="zentra-admin-success-dialog">
  <h1 mat-dialog-title class="dialog-title-row">
    User Invite
    <button
      mat-icon-button
      *ngIf="!successMessage"
      class="close-button"
      (click)="dialogRef.close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </h1>
  <div mat-dialog-content class="message">
    <h3 *ngIf="!successMessage">
      Please select role and enter user's email Address. They will be granted
      corresponding access and permissions.
    </h3>

    <div *ngIf="successMessage" class="success-message-container">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h3 class="success-message">{{ successMessage }}</h3>
    </div>
    <br />

    <form [formGroup]="emailForm" *ngIf="!successMessage">
      <div formArrayName="emails" class="email-list">
        <div
          *ngFor="let email of emails.controls; let i = index"
          [formGroupName]="i"
          class="user-entry-card"
        >
          <button
            type="button"
            class="remove-entry-button"
            (click)="removeEmail(i)"
            [disabled]="emails.length === 1"
          >
            <mat-icon>highlight_off</mat-icon>
          </button>
          <mat-form-field
            floatLabel="always"
            appearance="outline"
            class="full-width"
          >
            <mat-label>Enter Email Address</mat-label>
            <input
              matInput
              type="email"
              formControlName="email"
              required
            />
            <mat-error *ngIf="email.get('email')?.hasError('required')">
              Please enter an email address.
            </mat-error>
            <mat-error *ngIf="email.get('email')?.hasError('email')">
              Please enter a valid email address.
            </mat-error>
          </mat-form-field>
          <div class="role-toggle-row">
            <div
              class="role-toggle integrator"
              [class.selected]="email.get('role')?.value === 'Integrator'"
              (click)="selectRole(i, 'Integrator')"
            >
              <mat-icon>person</mat-icon>
              <span>Integrator</span>
            </div>
            <div
              class="role-toggle wholesaler"
              [class.selected]="email.get('role')?.value === 'Wholesaler'"
              (click)="selectRole(i, 'Wholesaler')"
            >
              <mat-icon>storefront</mat-icon>
              <span>Wholesaler</span>
            </div>
          </div>
        </div>
      </div>
      <div class="email-list-header">
        <button mat-flat-button color="secondary" (click)="addEmail()">
          <mat-icon>add</mat-icon> Add Another User
        </button>
      </div>

      <div *ngIf="inviteErrorMessage" class="error-message">
        <mat-icon>error_outline</mat-icon>
        <div class="error-content">
          <strong>Unable to Invite</strong>
          <p *ngIf="failedEmailMessages.length <= 1">{{ inviteErrorMessage }}</p>
          <ul class="failed-emails-list" *ngIf="failedEmailMessages.length > 1">
            <li *ngFor="let message of failedEmailMessages">{{ message }}</li>
          </ul>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="actions">
    <button
      color="secondary"
      mat-flat-button
      *ngIf="!successMessage"
      (click)="dialogRef.close()"
    >
      Cancel
    </button>
    <button
      color="primary"
      mat-flat-button
      *ngIf="!successMessage"
      [disabled]="emailForm.invalid"
      (click)="inviteIntegrators()"
    >
      Send Invite
    </button>
    <button
      color="primary"
      mat-flat-button
      *ngIf="successMessage"
      (click)="dialogRef.close()"
    >
      Close
    </button>
  </div>
</div>
